import { WEEKDAYS } from "@/lib/programWeek";

// #74 — schedule rows can carry stray whitespace (" Rest", " Tuesday") from before trim-on-save
// (#75), and there is no backfill (a production data write). The generated useListSchedules hook
// can't be edited, so every page normalises the hook's data once, here, before comparing or
// rendering: a padded day then lands on the right day, a padded Rest is not counted as a session,
// and " Tuesday" never renders as " Tu". Mirrors the server readers, which trim and fold case.

type Normalisable = { sessionType: string; dayOfWeek: string };

/** Trims sessionType and dayOfWeek; a day is mapped to its canonical name ("tuesday " → "Tuesday"). */
export function normaliseScheduleEntry<T extends Normalisable>(entry: T): T {
  const day = entry.dayOfWeek.trim();
  const dayOfWeek = WEEKDAYS.find((d) => d.toLowerCase() === day.toLowerCase()) ?? day;
  const sessionType = entry.sessionType.trim();
  if (dayOfWeek === entry.dayOfWeek && sessionType === entry.sessionType) return entry;
  return { ...entry, dayOfWeek, sessionType };
}

export function normaliseScheduleEntries<T extends Normalisable>(entries: readonly T[]): T[] {
  return entries.map(normaliseScheduleEntry);
}
